import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { Form } from 'antd';
import moment from 'moment';
import { useHistory, useParams } from 'react-router';
import Selectors from '../selectors';
import SelectorsApp from '@sharedComponent/app-action-reducer/selectors';
import { setStartDate } from '@helpers';
import { datePickerValues, dateFormats, appVariables } from '@constants';
import ViewSummaryPresentational from './view-summary-presentational';
import Actions from '../action';

const ViewSummaryFunctional = ({ userDetails, getCommissionSummaryByID, modalOptions, 
	commissionSummaryByAffData, commissionSummaryByAffDataLoading,
	updateCommissionSummaryByID, setModalOptions, transferCommissionSummaryByID,
	editCommissionSummaryByIDError, editCommissionSummaryByIDLoading }) => {
	const history = useHistory();
	const { affiliateId } = useParams();
	const [formRef] = Form.useForm();
	const [request, setRequest] = useState({
		fromDate: moment(setStartDate(datePickerValues.LAST)).format(dateFormats.MM_DD_YYYY),
		toDate: moment(new Date()).format(dateFormats.MM_DD_YYYY),
		affiliateId,
	});

	const [state, setState] = useState({
		loading: false,
	});

	const [showCreateComm, setshowCreateComm] = useState(false)

	const setModalOptionsValues = (modalType = null, modalVisible = false, rowVals) => {
		const values = modalVisible
			? {
					modalType,
					modalVisible,
			  }
			: {
					modalType: null,
					modalVisible: false,
			  };
			  
		setModalOptions({
			...modalOptions,
			...values,
		});
		setSummaryForm({
			...summaryForm,
			rowVal: rowVals
		});
	};

	const handleSetState = (label, value) => {
		setState({
			...state,
			[label]: value,
		});
	};

	const [summaryForm, setSummaryForm] = useState({
		summaryModal: false,
		summaryType: 'Add',
		rowVal: {}
	});

	const handleSummaryForm = (label, value) => {
		setSummaryForm({
			...summaryForm,
			[label]: value,
		});
	};

	formRef.setFieldsValue(summaryForm.rowVal);

	const onFinishModal = (value, modalType) => {
		modalType && appVariables.EDIT_COMMISSION ?
			updateCommissionSummaryByID(value, history, affiliateId) :
			transferCommissionSummaryByID(value, history, affiliateId)
	};

	useEffect(() => {
		getCommissionSummaryByID(request, history);
	}, []);

	return (
		<ViewSummaryPresentational
			onFinishModal={onFinishModal}
			showCreateComm={showCreateComm}
			setshowCreateComm={setshowCreateComm}
			formRef={formRef}
			handleSummaryForm={handleSummaryForm}
			summaryForm={summaryForm}
			handleSetState={handleSetState}
			state={state}
			userDetails={userDetails}
			modalOptions={modalOptions}
			setModalOptionsValues={setModalOptionsValues}
			editCommissionSummaryByIDLoading={editCommissionSummaryByIDLoading}
			commissionSummaryByAffData={commissionSummaryByAffData}
			commissionSummaryByAffDataLoading={commissionSummaryByAffDataLoading}
			editCommissionSummaryByIDError={editCommissionSummaryByIDError}
		/>
	);
};

const mapStateToProps = (state) => {
	return {
		userDetails: SelectorsApp.userDetails(state),
		modalOptions: Selectors.modalOptions(state),
		editCommissionSummaryByIDLoading: Selectors.editCommissionSummaryByIDLoading(state),
		commissionSummaryByAffData: Selectors.commissionSummaryByAffData(state),
		commissionSummaryByAffDataLoading: Selectors.commissionSummaryByAffDataLoading(state),
		editCommissionSummaryByIDError: Selectors.editCommissionSummaryByIDError(state),
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		getCommissionSummaryByID: (request, history) => dispatch(Actions.creators.getCommissionSummaryByID(request, history)),
		updateCommissionSummaryByID: (request, history, affiliateId) => dispatch(Actions.creators.updateCommissionSummaryByID(request, history, affiliateId)),
		transferCommissionSummaryByID: (request, history, affiliateId) => dispatch(Actions.creators.transferCommissionSummaryByID(request, history, affiliateId)),
		setModalOptions: (modalOptions) => dispatch(Actions.creators.setModalOptions(modalOptions)),
	};
};

const Connected = connect(mapStateToProps, mapDispatchToProps)(ViewSummaryFunctional);

export default Connected;
